// (c) 2026 Owl Consultations. All rights reserved.
// Proprietary and confidential — licensed use only.

import type { ReactNode } from 'react'
import { StyledEngineProvider, ThemeProvider } from '@mui/material/styles'
import { appTheme } from './theme'

/**
 * D-UI-3 §3 — mounts the kit's theme. `injectFirst` puts MUI's styles before index.css so the app's
 * existing rules keep winning ties; no CssBaseline (index.css already is the baseline) and no CSS layer
 * (an unlayered `button` rule would then beat filled MUI buttons). CSP is unchanged: style-src already
 * allows 'unsafe-inline', which Emotion needs (staticwebapp.config.json).
 */
export default function AppThemeProvider({ children }: { children: ReactNode }) {
  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={appTheme}>{children}</ThemeProvider>
    </StyledEngineProvider>
  )
}
